import { connect } from 'react-redux';
import PreviewScreen from '../components/PreviewScreen';
import { getScreenStyles } from '../selectors/layout';
import { getPreviewScreenImgURL } from '../selectors/screen';
function mapStateToProps(state) {
    var _a = getScreenStyles(state, true), imageWidth = _a.imageWidth, imageHeight = _a.imageHeight;
    var imageURL = getPreviewScreenImgURL(state);
    return { imageWidth: imageWidth, imageHeight: imageHeight, imageURL: imageURL };
}
export default connect(mapStateToProps)(PreviewScreen);
